import { RemoteData } from '@lycoris-nubila/ngx-lycoris';
import { Observable } from 'rxjs';

import { IPhase } from '../../../domain/phase/phase';

export abstract class PhaseApplicationPort {
	public abstract observePhasesByUserId(
		userId: string
	): Observable<RemoteData<IPhase[]>>;
}
